import { createApp, watch } from 'vue'
import App from './App.vue'
import { getDefaultLocale } from './store/modules/locale';
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

// Bot detection is now handled server-side by Vercel API routes
// This ensures proper HTTP redirects for all clients including curl, bots, etc.

// -------------------------------------------------------------------- Store
import store from './store'

// -------------------------------------------------------------------- Router

// -------------------------------------------------------------------- JQuery
// import $ from 'jquery';

// -------------------------------------------------------------------- Masonry
import VueMasonry from 'vue3-masonry';

// -------------------------------------------------------------------- Apollo Client
import apolloClient from "./services/apollo-client";
import { DefaultApolloClient } from "@vue/apollo-composable";

// -------------------------------------------------------------------- Locale
import { i18n } from './services/i18n.js'

// -------------------------------------------------------------------- dayjs
import dayjs from '@/utils/dayjs'

// -------------------------------------------------------------------- posthog
import posthogService from "./services/posthog.js"; //import the plugin. 

// -------------------------------------------------------------------- App Assets CSS
import './assets/css/base.css';
import './assets/css/main.css';
import './assets/css/vendor.css';

// -------------------------------------------------------------------- App Assets JS
import './assets/js/main.js';

// -------------------------------------------------------------------- Bugsnag
// Importing the Bugsnag services
// import Bugsnag from '@bugsnag/js'
// import BugsnagPluginVue from '@bugsnag/plugin-vue'
// import BugsnagPerformance from '@bugsnag/browser-performance'

// Initialize Bugsnag with your API key
// Bugsnag.start({
//   apiKey: process.env.VUE_APP_BUGSNAG_API_KEY,
//   plugins: [new BugsnagPluginVue()]
// })

// Initialize performance monitoring
// BugsnagPerformance.start({
//   apiKey: process.env.VUE_APP_BUGSNAG_API_KEY
// })

// Get the Vue plugin from Bugsnag
// const bugsnagVue = Bugsnag.getPlugin('vue')

// app.use(bugsnagVue)

// -------------------------------------------------------------------- Watch Locale

// Supress message observer error
window.addEventListener('error', (e) => {
  if (
    e.message === 'ResizeObserver loop completed with undelivered notifications.' ||
    e.message === 'ResizeObserver loop limit exceeded'
  ) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

// Mount the app normally - bot detection is handled server-side
const defaultLocale = getDefaultLocale();
const app = createApp(App)

app.use(store);
app.use(router);
app.use(VueMasonry)
app.provide(DefaultApolloClient, apolloClient);
app.use(i18n); // Use I18n
dayjs.locale(defaultLocale)
app.use(posthogService);
app.use(ElementPlus);

// Make store available to router
router.app = app;
app.config.globalProperties.$store = store;

watch(
    () => i18n.global.locale.value,
    (newLocale) => {
      dayjs.locale(newLocale)
    }
)

app.mount('#app')